module.exports = __webpack_public_path__ + "34bc775d/img/arrow-left-icon.785c715c.svg";